import { Skeleton } from '@material-ui/lab'
import React, { FC, ReactElement } from 'react'

/**
 * Configure agents loader.
 */
export const ConfigureAgentsLoader: FC = (): ReactElement => (
    <div className='tabs-content-loader configure-agents-loading'>
        <div className='tabs-menu-loaders'>
            <Skeleton variant='text' width='100%' height={40} />
            <Skeleton variant='text' width='100%' height={40} />
            <Skeleton variant='text' width='100%' height={40} />
            <Skeleton variant='text' width='100%' height={40} />
            <Skeleton variant='text' width='100%' height={40} />
            <Skeleton variant='text' width='100%' height={40} />
        </div>
        <div className='tabs-content-loaders'>
            <div className='section'>
                <Skeleton variant='text' width='100%' height={45} />
                <Skeleton variant='text' width='100%' height={45} />
                <Skeleton variant='text' width='100%' height={45} />
                <Skeleton variant='text' width='100%' height={45} />
                <Skeleton variant='text' width='100%' height={45} />
                <Skeleton variant='text' width='100%' height={45} />
                <Skeleton variant='text' width='100%' height={45} />
            </div>
        </div>
    </div>
)
